import { createIcons, Backpack, Calendar, ChevronDown, ChevronLeft, ChevronRight, Globe, MapPin, Search, SquarePen, Trash, User } from 'lucide';

/**
 * Iconos usados en vistas no-React (data-lucide="nombre-kebab").
 * Añade aquí nuevos imports + entrada en el objeto REGISTRY para mantener tree-shaking.
 */
const REGISTRY = {
  Backpack,
  Calendar,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  Globe,
  MapPin,
  Search,
  SquarePen,
  Trash,
  User
};

/**
 * Sustituye nodos <i data-lucide> (o equivalente) por SVG dentro de `root`.
 * Llamar tras inyectar HTML (p. ej. #remote_container) vía UJS.
 */
export function initLucideIcons(root = document) {
  if (typeof document === 'undefined' || !root) return;

  createIcons({
    icons: REGISTRY,
    nameAttr: 'data-lucide',
    root,
    attrs: {
      width: 18,
      height: 18,
      'stroke-width': 2
    }
  });
}
